import React from "react";
import { VideoIdField } from "../src/VideoIdField.tsx";

const textEditor = {
    type: "block",
    styles: [],
    marks: {
        decorators: [
            { value: "em" },
        ],
    },
}

export default {
    name: 'work',
    type: 'document',
    title: 'Work',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: "array",
            of: [{
                type: "block",
                styles: [],
                lists: [],
                marks: {
                    decorators: [
                        { title: 'Italic', value: "em" },
                    ],
                    annotations: [],
                },

            }],
            validation: Rule => Rule.required(),
        },
        {
            title: 'Slug',
            name: 'slug',
            type: 'slug',
            validation: Rule => Rule.required(),
            options: {
                source: 'title',
                maxLength: 200, // will be ignored if slugify is set
                slugify: input => toPlainText(input)
                    .toLowerCase()
                    .replace(/(<([^>]+)>)/ig, '')
                    .replace(/\s+/g, '-')
                    .replace(/[ .,:;`'"<>?!@£$%^&*()~‘’\[\]–—]|\n|\r/g, '')
                    .replace(/--+/g, '-')
                    .replace(/-$/g, '')
                    .slice(0, 200)
            }
        },
        {
            title: 'Date',
            name: 'date',
            type: 'date',
            validation: Rule => Rule.required(),
            options: {
                dateFormat: 'DD.MM.YYYY',
            }
        },
        {
            title: 'Location',
            name: 'location',
            type: 'array',
            of: [
                {
                    type: 'reference',
                    to: [
                        { type: 'workLocation' },
                    ]
                }
            ]
        },
        {
            title: 'Type',
            name: 'type',
            type: 'array',
            of: [
                {
                    type: 'reference',
                    to: [
                        { type: 'workType' },
                    ]
                }
            ]
        },
        {
            title: 'Medium',
            name: 'medium',
            type: 'array',
            of: [
                {
                    type: 'reference',
                    to: [
                        { type: 'workMedium' },
                    ]
                }
            ]
        },
        {
            type: "object",
            name: "thumbnail",
            title: "Thumbnail",
            validation: Rule => Rule.required(),
            fields: [
                {
                    title: 'Type',
                    name: 'type',
                    type: 'string',
                    validation: Rule => Rule.required(),
                    options: {
                        list: [
                            { title: 'Image', value: 'image' },
                            { title: 'Video', value: 'video' }
                        ],
                        layout: 'radio'
                    },
                    initialValue: 'image',
                },
                {
                    type: "object",
                    name: "video",
                    title: "Vimeo Url",
                    hidden: ({ parent, value }) => parent?.type != 'video',
                    inputComponent: VideoIdField,
                    fields: [
                        {
                            type: "string",
                            name: "url",
                            title: "Video URL",
                        },
                        {
                            type: "string",
                            name: "title",
                            title: "Video Title",
                            readOnly: true,
                        },
                        {
                            type: "string",
                            name: "id",
                            title: "Video ID",
                            readOnly: true,
                        },
                        {
                            type: "string",
                            name: "service",
                            title: "Service",
                            readOnly: true,
                        },
                        {
                            type: "string",
                            name: "thumbnail",
                            title: "Thumbnail",
                            readOnly: true,
                        },
                        {
                            type: "number",
                            name: "ratio",
                            title: "Ratio",
                            readOnly: true,
                        },
                    ],
                },
                {
                    title: 'Image',
                    name: 'image',
                    type: 'image',
                    hidden: ({ parent, value }) => parent?.type != 'image',
                }
            ],
            preview: {
                select: {
                    // id: "id",
                    type: "type",
                    video: "videoId",
                    image: "image"
                },
                prepare({ type = "", video, image }) {
                    return {
                        media: () => (<img src={type == 'video' ? video?.thumbnail : 'https://cdn.sanity.io/images/0lkrnbuy/production/' + image?.asset?._ref.replace(/image-/g, '').replace(/-([jpengtifwb]+)$/g, '.$1')} style={{ 'object-fit': 'cover' }
                        } />),
                    };
                }
            },
        },

        {
            title: 'Large Thumbnail',
            description: 'Works for landscape images only',
            name: 'largeThumb',
            type: 'boolean'
        },

        {
            title: "Description",
            name: "description",
            type: "array",
            of: [textEditor],
        },

        {
            title: 'Gallery',
            name: 'gallery',
            type: 'array',
            options: {
                layout: 'grid',
            },
            of: [
                {
                    type: "object",
                    name: "media",
                    title: "Media",
                    fields: [
                        {
                            title: 'Type',
                            name: 'type',
                            type: 'string',
                            options: {
                                list: [
                                    { title: 'Image', value: 'image' },
                                    { title: 'Video', value: 'video' }
                                ],
                                layout: 'radio'
                            },
                            initialValue: 'image',
                        },
                        {
                            type: "object",
                            name: "videoId",
                            title: "Vimeo Url",
                            hidden: ({ parent, value }) => !value && parent?.type != 'video',
                            inputComponent: VideoIdField,
                            fields: [
                                {
                                    type: "string",
                                    name: "url",
                                    title: "Video URL",
                                },
                                {
                                    type: "string",
                                    name: "title",
                                    title: "Video Title",
                                    readOnly: true,
                                },
                                {
                                    type: "string",
                                    name: "id",
                                    title: "Video ID",
                                    readOnly: true,
                                },
                                {
                                    type: "string",
                                    name: "service",
                                    title: "Service",
                                    readOnly: true,
                                },
                                {
                                    type: "string",
                                    name: "thumbnail",
                                    title: "Thumbnail",
                                    readOnly: true,
                                },
                                {
                                    type: "number",
                                    name: "ratio",
                                    title: "Ratio",
                                    readOnly: true,
                                },
                            ],
                        },
                        {
                            title: 'Image',
                            name: 'image',
                            type: 'image',
                            hidden: ({ parent, value }) => !value && parent?.type != 'image',
                        }
                    ],
                    preview: {
                        select: {
                            // id: "id",
                            type: "type",
                            video: "videoId",
                            image: "image"
                        },
                        prepare({ type = "", video, image }) {
                            return {
                                media: () => (<img src={type == 'video' ? video?.thumbnail : 'https://cdn.sanity.io/images/0lkrnbuy/production/' + image?.asset?._ref.replace(/image-/g, '').replace(/-([jpengtifwb]+)$/g, '.$1')} style={{ 'object-fit': 'cover' }
                                } />),
                            };
                        },
                    },
                }
            ],
        },
    ],
    preview: {
        select: {
            title: "title",
            date: "date",
            thumbnail: 'thumbnail'
        },
        prepare({ title = "", thumbnail, date }) {
            return {
                title: toPlainText(title),
                subtitle: date ? date.split('-').reverse().join('.') : null,
                media: () => (<img style={{ 'object-fit': 'cover' }} src={thumbnail ? thumbnail.type == 'image' ? thumbnail.image && thumbnail.image.asset && thumbnail.image.asset._ref ? 'https://cdn.sanity.io/images/0lkrnbuy/production/' + thumbnail.image.asset._ref.replace('image-', '').replace(/-([a-z]+)$/, '.$1') : null : thumbnail.video && thumbnail.video.thumbnail ? thumbnail.video.thumbnail : null : null} />),
            };
        }
    },
}

function toPlainText(blocks = []) {
    return blocks
        // loop through each block
        .map(block => {
            // if it's not a text block with children, 
            // return nothing
            if (block._type !== 'block' || !block.children) {
                return ''
            }
            // loop through the children spans, and join the
            // text strings
            return block.children.map(child => child.text).join('')
        })
        // join the paragraphs leaving split by two linebreaks
        .join('\n\n')
}


// WEBPACK FOOTER //
// ./schemas/work.js